
































import Vue from "vue";
import { Component, Emit, Prop } from "vue-property-decorator";
import { translate } from "../../services/translation/translation";
import './_progressbar.less';

@Component
export default class progressbar extends Vue {
    @Prop() progressbar;

    private data: any = {
        progressbarLocal:{
            'step0': '',
            'step1': '',
            'step2': '',
            'step3': ''
        }

    };

    mounted(){
        this.data.progressbarLocal = this.progressbar;
    }

    trans(key) {
        return translate(key);
    }

}
